module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/trapezeartist.1667c84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/trapezeartist.jpg
// module id = zbD4
// module chunks = 0